import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "component-development"
    }}>{`Component development`}</h1>
    <p>{`Adobe Commerce and Magento Open Source are flexible and as a result have varied functionality, so developing a component takes into account a number of different topics. Read the information on compatibility `}{`—`}{` `}<a parentName="p" {...{
        "href": "service-contracts/index.md"
      }}>{`Service Contracts`}</a>{`, `}<a parentName="p" {...{
        "href": "service-contracts/design-patterns.md"
      }}>{`Design Patterns`}</a>{`, and the information on `}<a parentName="p" {...{
        "href": "dependency-injection.md"
      }}>{`Dependency Injection`}</a>{`, `}<a parentName="p" {...{
        "href": "routing.md"
      }}>{`Routing`}</a>{`, and `}<a parentName="p" {...{
        "href": "api-concepts.md"
      }}>{`Working With Public Interfaces and APIs`}</a>{` closely; they are essential for creating a good component.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Compatibility (backward and forward)`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "service-contracts/index.md"
            }}>{`Service contracts`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "service-contracts/design-patterns.md"
            }}>{`Design patterns`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "api-concepts.md"
          }}>{`Working with public interfaces and APIs`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "dependency-injection.md"
          }}>{`Object manager and dependency injection`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "code-generation.md"
          }}>{`Code generation`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "attributes.md"
          }}>{`EAV attributes`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "plugins.md"
          }}>{`Plug-ins (aka interceptors)`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "routing.md"
          }}>{`Routing`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "indexing/index.md"
          }}>{`Indexing`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "web-api/services.md#configure-a-web-api"
          }}>{`Configure a service as a web API`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "view-models.md"
          }}>{`ViewModels`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      